import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import footerLogo from '../../../assets/images/resources/ubrandit-logo.svg';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState('');

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setMessage('Please enter your email address');
      return;
    }

    setIsSubmitting(true);
    setMessage('');

    try {
      const response = await fetch('/api/newsletter', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          email: email,
          source: 'footer'
        }),
      });

      const result = await response.json();

      if (response.ok) {
        setMessage('Thank you! You\'ve been subscribed to our newsletter.');
        setEmail('');
      } else {
        setMessage(result.error || 'Something went wrong. Please try again.');
      }
    } catch (error) {
      setMessage('Network error. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
    {/* Site Footer Start */}
    <footer className="site-footer">
        <div className="site-footer__top">
            <div className="container">
                <div className="site-footer__top-inner">
                    <div className="site-footer__logo">
                        <Link to="/">
                            <img src={footerLogo} alt="" />
                        </Link>
                    </div>
                    {/* Social media links omitted for now */}
                </div>
            </div>
        </div>
        <div className="site-footer__middle">
            <div className="container">
                <div className="site-footer__middle-inner">
                    <div className="row">
                        <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="100ms">
                            <div className="footer-widget__column footer-widget__events">
                                <div className="footer-widget__title-box">
                                    <h3 className="footer-widget__title">About</h3>
                                </div>
                                <div className="footer-widget__text">
                                    <p>Your trusted partner for quality promotional products and branded merchandise.</p>
                                    <p className="footer-slogan">On Time • On Point • On Budget</p>
                                    <p style={{marginTop: '20px'}}><a href="tel:8007215822" style={{color: '#fff', fontSize: '18px'}}>800-721-5822</a></p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="200ms">
                            <div className="footer-widget__column footer-widget__link">
                                <div className="footer-widget__title-box">
                                    <h3 className="footer-widget__title">Quick Links</h3>
                                </div>
                                <ul className="footer-widget__link-list list-unstyled">
                                    <li><Link to="/">Home</Link></li>
                                    <li><Link to="/services">Services</Link></li>
                                    <li><Link to="/contact">Contact Us</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="300ms">
                            <div className="footer-widget__column footer-widget__our-company">
                                <div className="footer-widget__title-box">
                                    <h3 className="footer-widget__title">Products</h3>
                                </div>
                                <ul className="footer-widget__link-list list-unstyled">
                                    <li><Link to="/services">Custom Apparel</Link></li>
                                    <li><Link to="/services">Promotional Items</Link></li>
                                    <li><Link to="/services">Corporate Gifts</Link></li>
                                    <li><Link to="/services">Trade Show Products</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="400ms">
                            <div className="footer-widget__column footer-widget__contact">
                                <div className="footer-widget__title-box">
                                    <h3 className="footer-widget__title">Get Updates</h3>
                                </div>
                                <div className="footer-widget__newsletter">
                                    <p className="footer-widget__newsletter-text">Join our mailing list for promotional ideas and special offers</p>
                                    <form className="footer-widget__newsletter-form" onSubmit={handleNewsletterSubmit}>
                                        <div className="footer-widget__newsletter-input-box">
                                            <input 
                                                type="email" 
                                                placeholder="Your email" 
                                                name="email"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                disabled={isSubmitting}
                                            />
                                            <button 
                                                type="submit" 
                                                className="footer-widget__newsletter-btn thm-btn"
                                                disabled={isSubmitting}
                                            >
                                                {isSubmitting ? 'Subscribing...' : 'Subscribe'}
                                            </button>
                                        </div>
                                        {message && (
                                            <p className="footer-widget__newsletter-message" style={{
                                                marginTop: '10px',
                                                fontSize: '14px',
                                                color: message.includes('Thank you') ? '#28a745' : '#dc3545'
                                            }}>
                                                {message}
                                            </p>
                                        )}
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="site-footer__bottom">
            <div className="container">
                <div className="site-footer__bottom-inner">
                    <p className="site-footer__bottom-text">© 2024 U Brand It. All Rights Reserved.</p>
                    <ul className="list-unstyled site-footer__bottom-menu">
                        <li><Link to="/privacy">Privacy Policy</Link></li>
                        <li><Link to="/terms">Terms of Service</Link></li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
    {/* Site Footer End */}
    </>
  );
};

export default Footer;
